import React from 'react'

export const ApplicationContext = React.createContext()
export const SnackbarContext = React.createContext()

export default {
  ApplicationContext,
  SnackbarContext,
}
